module.exports = __webpack_public_path__ + "static/img/77.ddf66b9.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/notice/77.png
// module id = dLgK
// module chunks = 1